import * as React from 'react';


export const CandidateResume = ({
  resumeLink,
  candidateName,
}: {
  resumeLink: string;
  candidateName: string;
}) => {
  return (
    <iframe
      src={resumeLink}
      title={`Resume for ${candidateName}`}
      style={{height: '650px'}}
    ></iframe>
  );
};
